import { render, staticRenderFns } from "./PriceWrapper.vue?vue&type=template&id=1726db64&"
import script from "./PriceWrapper.vue?vue&type=script&lang=js&"
export * from "./PriceWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports